(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSFuncionarioDialogController', SSFuncionarioDialogController);

    SSFuncionarioDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'SSFuncionario', 'SSPersona', 'Sexo'];

    function SSFuncionarioDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, SSFuncionario, SSPersona, Sexo) {
        var vm = this;

        vm.sSFuncionario = entity;
        vm.sexos = Sexo.query();
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            console.log(vm.sSFuncionario);
            if (vm.sSFuncionario.id !== null) {
                SSFuncionario.update(vm.sSFuncionario, onSaveSuccess, onSaveError);
            } else {
                SSFuncionario.save(vm.sSFuncionario, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSFuncionarioUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.iniFunciones = false;
        vm.datePickerOpenStatus.finFunciones = false;
        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
